import React, { useEffect, useState } from 'react'
import './css/bootstrap.min.css'
import review from './img/revew'
import images from './the img/img'
import Mycv from './mycv'


function Port() {



    const [defaultImage, setDefaultImages] = useState(0);
    useEffect(()=>{
        setInterval(()=>{
            if (images.length >= 6) {
                setDefaultImages(0)
            }
            setDefaultImages(defaultImage + 1)
        },2000)
    }, [defaultImage])
    const [read, setRead] = useState('Read More');
    // const toogle = document.getElementById('toogle');
   
  return (
    <div>
         <nav className='navbar navbar-expand-lg navbar-dark bg-primary'>
            <div className="container">
                <a class="navbar-brand" href='#'>Dev Godwin</a>
                <button className='navbar-toggler' type='button'  data-toogle='collapse'  data-target='#navbarSupportedContent'>
                    <span className='navbar-toggler-icon'></span>
                </button>

                <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                <ul class="navbar-nav ml-auto">
                    <li className="nav-item">
                    <a href="/home" className='nav-link'>Home</a>
                    </li>
                    <li className='nav-item dropdown'>
                    <a href="/about" className='nav-link dropdown-toggle' id='navbarDropdown' data-toggle='dropdown'>About</a>
                    <div className="dropdown-menu">
                        <a href="https://github.com/webgod1" className="dropdown-item">Github Link</a>
                        <a href="https://www.linkedin.com/in/godwin-samuel479723254" className="dropdown-item">LinkedIn Link</a>
                        <a href="https://www.twitter.com/Godwinsam2006" className="dropdown-item">Twitter Link</a>
                        <div className="dropdown-divider"></div>
                        <a href="/mycv" className="dropdown-item">Resume</a>
                        <a href="/about" className="dropdown-item">About Link</a>

                    </div>
                    </li>
                    <li className='nav-item'>
                    <a href="/project" className='nav-link'>Projects</a>
                    </li>
                    <li className='nav-item'>
                    <a href="#" className='nav-link'>Contact Me</a>
                    </li>
                </ul>
                </div>
            </div>
         </nav>
         <div className='my-img text-center'>
            <h1 className='text-center'>Hello I'm Samuel Godwin</h1>
            <p className='text-center'>I'm a front-end developer</p>
            {/* <button style={{marginTop: '250px', position: 'absolute', left: '47%' }} className='btn btn-primary text-center '>Leave A Message</button> */}
            <img src={images[0]} alt="" />
         </div>
         <div className='body-div'>
         <div className='container'>
            <div className="jumbotron">
                <h2 className='text-center'>About Dev Godwin</h2>
                <p>I’m a frontend developer with 2 years of experience using my design skills,
                     I create beautiful user interface for web applications,
                      and I also write tests and debug code to ensure quality.
                       Have a certificate in front End Devloper at <mark> Side Hustle Internship</mark> <a href='https://github.com/webgod1'> Github</a> <a href="/project">Projects</a> <a href="/about">About</a> </p>
                <div id='demo'>Lorem ipsum dolor, sit amet 
                    consectetur adipisicing elit. Iste autem fuga voluptate temporibus amet doloremque, 
                    distinctio provident ducimus corrupti quibusdam vitae minima itaque 
                    obcaecati laboriosam, repellat odio! Magnam sunt suscipit a, 
                    dignissimos provident doloremque!</div>
                    <a href='/mycv' className='btn btn-primary'>Resume</a>
            </div>
         </div>
                <div className='container'>
                    <h2 className='text-center'>Review On Some Project I Work on</h2>
                    <div className='row'>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px'}} src={images[1]} alt="" />
                                <h2 className='mt-2 ml-2'>Yelp Camp</h2>
                                <p className='mt-2 ml-2'>A website for camping, adventure and new experience for everyone. Built with React.js and Firebase</p>
                                <button className='btn btn-primary'>Check Out</button>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px'}} src={images[1]} alt="" />
                                <h2 className='mt-2 ml-2'>Twitter Data Analysis</h2>
                                <p className='mt-2 ml-2'>A Twitter Clone website.  Built with HTML, CSS AND JAVASCRIPT</p>
                                <button className='btn btn-primary'>Check Out</button>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px'}} src={images[1]} alt="" />
                                <h2 className='mt-2 ml-2'>TicTaTook Game</h2>
                                <p className='mt-2 ml-2'>A Super fun game. Built with HTML, CSS and javascript</p>
                                <button className='btn btn-primary'>Check Out</button>
                            </div>
                        </div>
                    </div>           
                </div>
                <div className="container">
                    <h2 className='mt-3 mb-4 text-center'>Here are what Dev Godwin Can Do</h2>
                    <div className='row'>
                        <div className='col-lg-4 mt-3'>
                            <div className="card">
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px'}} src={review[0]} alt="" />
                                <h5 className='text-center mt-2'>Dev Godwin Build well responsive Layout and design </h5>
                            </div>
                        </div>
                        <div className='col-lg-4 mt-3'>
                            <div className="card">
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={review[1]} alt="" />
                                <h5 className='text-center mt-2'>Dev Godwin Build well responsive Layout and design </h5>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='card mt-2'>
                                <a className='btn btn-primary' href="https://github.com/webgod1">Github</a>
                                <br />
                                <a className='btn btn-primary' href="https://www.linkedin.com/in/godwin-samuel479723254">LinkedIn</a>
                                <br />
                                <a className='btn btn-primary' href='/mycv'>My CV</a>
                                <br />
                            </div>
                        </div>
                    </div>
                    <div className="container mt-4">
                        <div className="row">
                            <div className='col-lg-6 col-sm-12'>
                                <form className='form'>
                                    <h3>Leave A Message</h3>
                                    <label className='label mt-2' htmlFor="name">Name: </label>
                                    <input type="text" className='form-control' />
                                    <br />
                                    <label htmlFor="name">Email: </label>
                                    <input type="email" className='form-control' />
                                    <br />
                                    <label htmlFor="name">Messages: </label>
                                    <textarea name="message" style={{resize: 'none'}} className='form-control' cols="30" rows="10"></textarea>
                                    <br />
                                    <button type='submit' className='btn btn-primary mb-3'>Send Message</button>
                                </form>
                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <div className='card mt-5 mb-3 '>

                                <h3 className=' sm-mt-3 text-center'>Skills</h3>
                                <p className='btn btn-primary  ml-5' style={{width: '80%'}}>HTML</p>
                                <p className='btn btn-primary ml-5' style={{width: '80%'}}>CSS</p>
                                <p className='btn btn-primary ml-5' style={{width: '80%'}}>JAVASCRIPT</p>
                                <br />
                                <p className='btn btn-primary ml-5' style={{width: '80%'}}>BOOTSTRAP</p>
                                <p className='btn btn-primary ml-5' style={{width: '80%'}}>REACT.JS</p>
                                <p className='btn btn-primary ml-5' style={{width: '80%'}}>FIREBASE</p>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer'>
                    <div className='container mt-2'>
                    <h2 style={{color: 'white', position: 'absolute'}} className='mt-3'>Dev Godwin</h2>
                    <p className='text-right mt-3' style={{color: 'white', position: 'absolute', marginLeft: '650px'}} >Email-Address: godwinsamuel2113@gmail.com</p>
                    <p className='text-right mt-5' style={{color: 'white', position: 'absolute', marginLeft: '650px'}} >Phone Number: 09081008646</p>
                    <p className='text-right mt-7' style={{color: 'white', position: 'absolute', marginLeft: '650px', marginTop: '80px'}} >Github: Webgod1</p>
                    </div>
                </div>
         {/* <div style={{height: '500px'}}>

         </div> */}
         </div>
    </div>
  )
}

export default Port